const forms = [
  {
    name: "Credit Note",
    className: "bg-white p-4 rounded-md p-8 w-[100%] mx-auto",
    options: [
      {
        name: "Invoice",
        type: "select",
        form: {
          name: "invoice",
          allowClear: false,
          showSearch: true,
          filterOption: false,
          placeholder: "Select Invoice",
          api: "get-all-invoices",
          options: null,
          value: null,
          required: true,
          source:"Credit/Debit_Note"
        },
      },
      {
        name: "Customer",
        type: "input",
        form: {
          name: "customer",
          value: "",
          required: false,
        },
      },
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Credit Note Date",
          class: "",
          value: new Date(),
          required: true,
        },
      },
      {
        name: "Reason",
        type: "input",
        form: {
          name: "reason",
          placeholder: "Reason for credit note",
          value: "",
          required: true,
        },
      },
    ],
  },
];

export default forms;